import { AbsenceType } from 'xm-constants/absence';

export const SET_TEMP_ABSENCE_START = 'SET_TEMP_ABSENCE_START';
export const SET_TEMP_ABSENCE_END = 'SET_TEMP_ABSENCE_END';
export const SET_TEMP_ABSENCE_USER_DETAILS = 'SET_TEMP_ABSENCE_USER_DETAILS';
export const TEMP_ABSENCE_GROUP_TOGGLE = 'TEMP_ABSENCE_GROUP_TOGGLE';
export const TEMP_ABSENCE_ALL_GROUP_CHANGE = 'TEMP_ABSENCE_ALL_GROUP_CHANGE';
export const TEMP_ABSENCE_RESET_STATE = 'TEMP_ABSENCE_RESET_STATE';
export const SET_TEMP_ABSENCE_REPLACEMENT = 'SET_TEMP_ABSENCE_REPLACEMENT';
export const SET_TEMP_ABSENCE_DIALOG_OPEN = 'SET_TEMP_ABSENCE_DIALOG_OPEN';
export const SET_INCLUDE_DIRECT_NOTIFICATIONS =
  'SET_INCLUDE_DIRECT_NOTIFICATIONS';

export const TEMP_ABSENCE_SAVE = 'TEMP_ABSENCE_SAVE';
export const TEMP_ABSENCE_SAVE_START = `${TEMP_ABSENCE_SAVE}_START`;
export const TEMP_ABSENCE_SAVE_SUCCESS = `${TEMP_ABSENCE_SAVE}_SUCCESS`;
export const TEMP_ABSENCE_SAVE_FAIL = `${TEMP_ABSENCE_SAVE}_FAIL`;

export const GET_USER_GROUPS = 'GET_USER_GROUPS';
export const GET_USER_GROUPS_START = `${GET_USER_GROUPS}_START`;
export const GET_USER_GROUPS_SUCCESS = `${GET_USER_GROUPS}_SUCCESS`;
export const GET_USER_GROUPS_FAIL = `${GET_USER_GROUPS}_FAIL`;

export const GET_ORGANIZATION_CONFIG = 'GET_ORGANIZATION_CONFIG';
export const GET_ORGANIZATION_CONFIG_START = `${GET_ORGANIZATION_CONFIG}_START`;
export const GET_ORGANIZATION_CONFIG_SUCCESS = `${GET_ORGANIZATION_CONFIG}_SUCCESS`;
export const GET_ORGANIZATION_CONFIG_FAIL = `${GET_ORGANIZATION_CONFIG}_FAIL`;

export function setStart(time) {
  return {
    type: SET_TEMP_ABSENCE_START,
    payload: time,
  };
}

export function setEnd(time) {
  return {
    type: SET_TEMP_ABSENCE_END,
    payload: time,
  };
}

export function setUserDetails(user) {
  return {
    type: SET_TEMP_ABSENCE_USER_DETAILS,
    payload: user,
  };
}

export function setDialogOpen(isOpen) {
  return { type: SET_TEMP_ABSENCE_DIALOG_OPEN, payload: isOpen };
}

export function toggleGroupSelection(groupId) {
  return {
    type: TEMP_ABSENCE_GROUP_TOGGLE,
    payload: groupId,
  };
}

export function allGroupsChange() {
  return {
    type: TEMP_ABSENCE_ALL_GROUP_CHANGE,
  };
}

export function resetState() {
  return {
    type: TEMP_ABSENCE_RESET_STATE,
  };
}

export function setReplacement(user) {
  return {
    type: SET_TEMP_ABSENCE_REPLACEMENT,
    payload: user,
  };
}

export function getUserGroups(id) {
  return {
    type: GET_USER_GROUPS,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/people/${id}/group-memberships`,
      method: 'get',
    },
  };
}

export function getOrganizationConfig() {
  return {
    type: GET_ORGANIZATION_CONFIG,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/organization/config`,
      method: 'get',
    },
  };
}

export function setIncludeDirectNotifications(includeDirectNotifications) {
  return {
    type: SET_INCLUDE_DIRECT_NOTIFICATIONS,
    payload: includeDirectNotifications,
  };
}

export function saveAbsences(absences) {
  const params = absences.map(
    ({
      start,
      end,
      userId,
      replacementId,
      groupId,
      includeDirectNotifications,
    }) => {
      const absence = {
        start,
        end,
        absenceType: replacementId
          ? AbsenceType.REPLACEMENT
          : AbsenceType.VACANCY,
        member: {
          id: userId,
        },
        includeDirectNotifications,
      };

      if (replacementId) {
        absence.replacement = {
          id: replacementId,
        };
      }

      if (groupId) {
        absence.group = {
          id: groupId,
        };
      }

      return absence;
    },
  );

  return {
    type: TEMP_ABSENCE_SAVE,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/temporary-absences?method=PATCH`,
      method: 'post',
      params,
    },
  };
}
